module.exports = __webpack_public_path__ + "cbedb411a4d15ba85da9335cf3ad655b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/galeriaFotos/092.jpg
// module id = 63
// module chunks = 0